import { _,moment } from '../../../../vendor'
import InboomaBaseView from '../../InboomaBaseView'
import InboomaBaseCollectionView from '../../InboomaBaseCollectionView'
import { Biscuit, FormatHelper } from '../../../utils'

/**
 * @todo Fix #18369 (see test results in comments)
 * @todo Move inline-css into _finances.scss
 */

const reference_type_string = {
    // Enum reference types
    1 : 'client_account',
    2 : 'user_account',
    3 : 'resource',
    4 : 'location',
    9 : 'Inbooma'
};

const a = '${a}';

const WalletItemView = InboomaBaseView.extend({

  template : `
    <div class="inb-c-item-details-row row hide" style="background-color: red">
      <!-- Total sum of this wallet. Deactivated as requested in #20835 -->
    
      <div class="medium-8 column">
          <strong>
              <%= t('transactions_of_${a}', {a:t(reference_type_string[reference_type])}) %>
          </strong>
      </div>

      <div class="medium-4 text-right column">
          <% var color = ''
          if (withdrawable_amount !== 0 && withdrawable_amount !== null) {
              if (withdrawable_amount.toString().indexOf('-') >= 0) {
                  color = 'negative-amount'
              } else {
                  color = 'positive-amount2'
              }
          }
          %>
          <%- getAmount(current_balance) %><%- clientCurrency %> 
          (<%= t('withdrawable_cash') %>: 
          <strong>
            <%- getAmount(withdrawable_amount) %> €
          </strong>)
      </div>

    </div>

    <div id="inb-loader-container">
        <div class="inb-c-loader">
            <div class="inb-c-loader--item inb-c-loader--sidebar-center">
                <div class="inb-c-loader--bg row" style="height: 100px;">
                <div class="loader-mask vert-ph-1"></div>
                <div class="loader-mask vert-ph-2"></div> 
                <div class="loader-mask vert-ph-3"></div> 
                <div class="loader-mask vert-ph-4"></div> 
                </div>
            </div>
        </div>
    </div>
    
    <div class="inb-wallet-transactions-view-wrapper">
      
      <div class="inb-c-item">
        <div class="inb-c-loader">
          <div class="inb-c-loader--item inb-c-loader--sidebar-center">
            <div class="inb-c-loader--bg row" style="height: 100px;">
              <div class="loader-mask vert-ph-1"></div>
              <div class="loader-mask vert-ph-2"></div> 
              <div class="loader-mask vert-ph-3"></div> 
              <div class="loader-mask vert-ph-4"></div> 
            </div>
          </div>
        </div>
      </div>

        <!-- WalletTransactionsListView -->
    </div>`,

  className : 'inb-wallet-item',

  templateContext () {
    // @todo Un-used here, move to TransactionsItemView
    return {
       _,
       moment,
       reference_type_string,
       payment_type_string : {
         // Enum payment types
         // @todo export
         1 : this.t('cash',null,'capital'),
         2 : this.t('credit_card',null,'capital'),
         3 : this.t('sepa',null,'capital')
       },
       payment_status_string : {
         // Enum payment status
         // @todo export
         1 : this.t('pending'),
         2 : this.t('paid'),
         3 : this.t('payout'),
         4 : this.t('refund'),
         5 : 'Error'
       },
       clientCurrency : Biscuit.get('client.currency'),
       getAmount : (amount) => {
         console.log("amount: ",amount);
        return FormatHelper.currencyFormat(amount);
      }
    }
  },

});

export default InboomaBaseCollectionView.extend({
  
    el: '#inb-c-main .off-canvas-wrapper',
    childView: WalletItemView,
    childViewContainer: '.inb-wallet-transactions-list',
    template: `
      <div class="inb-wallets">
        
        <div class="inb-wallets-header clearfix">
         
          <% if (collection.models.length >= 1) {
              var mostPreciousWallet = _.max(collection.models, function(model){ return model.get('withdrawable_amount') })
              if (mostPreciousWallet !== -Infinity && mostPreciousWallet.get('withdrawable_amount') > 0) { %>
              <a
               href="my-inbooma/finances/payoutForm"
               class="small button hollow float-right hide"
               title="<%= t('withdrawable_cash') %>: <%- mostPreciousWallet.get('withdrawable_amount') %>"
               style="margin-right:1.25rem;">
                <i class="fi fi-credit-card"></i> <%= t('make_payout',null,'capital') %>
              </a>
            <% } %>
          <select
           id="change-wallet"
           name="change-wallet"
           class="medium-2 column float-right hide"
           title="<% t('change_wallet_info') %>"
           style="margin-right:1rem;">
          <% _.each(collection.models, function (wallet) { %>
            <option value="<%- wallet.get('id') %>">
                <%= t(reference_type_string[wallet.get('reference_type')]) %>
            </option>
          <% }); %>
          </select>
          <% } %>
        </div>

        <div class="inb-wallet-transactions-list">
        </div>

      </div>`,

    templateContext () {
        return {
            _,
            reference_type_string,
            collection: this.collection
        }
    },

    initialize () {
        this.render();
    },

});